<div class="register-container">
  <!-- Lado Izquierdo - Beneficios del Plan -->
  <div class="left-side">
    <div class="benefits-container">
      <div class="benefits-header">
        <div class="logo">
          <img src="./assets/logo/logon.png" width="180px" alt="Logo">
        </div>
        <h2 class="benefits-title">Únete a Nuestra Plataforma</h2>
        <p class="benefits-subtitle">Accede a contenido exclusivo y herramientas premium</p>
      </div>

      <!-- Step Indicator -->
      <div class="step-indicator">
        <div class="step" [class.active]="currentStep() === 1" [class.completed]="currentStep() === 2">
          <div class="step-number">1</div>
          <div class="step-label">Información</div>
        </div>
        <div class="step-line" [class.completed]="currentStep() === 2"></div>
        <div class="step" [class.active]="currentStep() === 2">
          <div class="step-number">2</div>
          <div class="step-label">Pago</div>
        </div>
      </div>

      <div class="benefits-list">
        <div class="benefit-item">
          <div class="benefit-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="rgba(119, 210, 122, 0.2)" />
              <path d="M10 16L14 20L22 12" stroke="#77d27a" stroke-width="2.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div class="benefit-content">
            <h3 class="benefit-title">Acceso Ilimitado</h3>
            <p class="benefit-description">Accede a todos los cursos y materiales educativos</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="rgba(119, 210, 122, 0.2)" />
              <path d="M16 8V16L20 20" stroke="#77d27a" stroke-width="2.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <circle cx="16" cy="16" r="8" stroke="#77d27a" stroke-width="2.5" />
            </svg>
          </div>
          <div class="benefit-content">
            <h3 class="benefit-title">Clases en Vivo</h3>
            <p class="benefit-description">Participa en sesiones interactivas</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="rgba(119, 210, 122, 0.2)" />
              <path d="M12 16L16 12L20 16M16 12V24" stroke="#77d27a" stroke-width="2.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M8 8H24" stroke="#77d27a" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
          <div class="benefit-content">
            <h3 class="benefit-title">Certificaciones</h3>
            <p class="benefit-description">Obtén certificados reconocidos</p>
          </div>
        </div>

        <div class="benefit-item">
          <div class="benefit-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="rgba(119, 210, 122, 0.2)" />
              <path d="M16 20C16 13.79 13.79 12 16 12C18.21 12 20 13.79 20 16C20 18.21 18.21 20 16 20" stroke="#77d27a"
                stroke-width="2.5" stroke-linecap="round" />
              <path d="M16 20V24M12 24H20" stroke="#77d27a" stroke-width="2.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        
        </div>
      </div>

      @if (selectedPlan()) {
      <div class="plan-badge">
        <div class="badge-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill="#77d27a" />
          </svg>
        </div>
        <div class="badge-content">
          <span class="badge-label">{{ selectedPlan()!.name }}</span>
          <span class="badge-price">${{ selectedPlan()!.price }}/{{ selectedPlan()!.duration === 'monthly' ? 'mes' :
            selectedPlan()!.duration === 'annual' ? 'año' : selectedPlan()!.durationDays + ' días' }}</span>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Lado Derecho - Formulario -->
  <div class="right-side">
    <div class="form-container">
      <!-- Back Button -->
      <button class="back-button" (click)="navigateToLogin()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M12 4L6 10L12 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>Volver al inicio de sesión</span>
      </button>

      <!-- STEP 1: User Information & Plan Selection -->
      @if (currentStep() === 1) {
      <div class="step-content">
        <h1 class="title">Crear Cuenta</h1>
        <p class="subtitle">Completa tu información y selecciona tu plan</p>

        <!-- Error Message -->
        @if (errorMessage()) {
        <div class="error-message">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="#ff4444" stroke-width="2" />
            <path d="M10 6V10M10 14H10.01" stroke="#ff4444" stroke-width="2" stroke-linecap="round" />
          </svg>
          <span>{{ errorMessage() }}</span>
        </div>
        }

        <!-- User Information Form -->
        <form [formGroup]="userInfoForm" class="register-form">
          <div class="form-group">
            <label class="form-label">Nombre Completo</label>
            <div class="input-wrapper"
              [class.valid]="userInfoForm.get('name')?.valid && userInfoForm.get('name')?.touched">
              <input type="text" formControlName="name" class="form-input" placeholder="Ingresa tu nombre completo" />
              <svg class="input-icon success" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#77d27a" />
                <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            @if (userInfoForm.get('name')?.invalid && userInfoForm.get('name')?.touched) {
            <span class="error-text">El nombre debe tener al menos 2 caracteres</span>
            }
          </div>

          <div class="form-group">
            <label class="form-label">Correo Electrónico</label>
            <div class="input-wrapper"
              [class.valid]="userInfoForm.get('email')?.valid && userInfoForm.get('email')?.touched">
              <input type="email" formControlName="email" class="form-input" placeholder="tu@email.com" />
              <svg class="input-icon success" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#77d27a" />
                <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            @if (userInfoForm.get('email')?.invalid && userInfoForm.get('email')?.touched) {
            <span class="error-text">Ingresa un correo electrónico válido</span>
            }
          </div>

          <div class="form-group">
            <label class="form-label">Número de Teléfono</label>
            <div class="input-wrapper"
              [class.valid]="userInfoForm.get('phone')?.valid && userInfoForm.get('phone')?.touched">
              <input type="tel" formControlName="phone" class="form-input" placeholder="12345678" />
              <svg class="input-icon success" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#77d27a" />
                <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            @if (userInfoForm.get('phone')?.invalid && userInfoForm.get('phone')?.touched) {
            <span class="error-text">Ingresa un número de teléfono válido (8-15 dígitos)</span>
            }
          </div>

          <div class="form-group">
            <label class="form-label">Contraseña</label>
            <div class="input-wrapper"
              [class.valid]="userInfoForm.get('contrasena')?.valid && userInfoForm.get('contrasena')?.touched">
              <input [type]="showPassword() ? 'text' : 'password'" formControlName="contrasena" class="form-input"
                placeholder="Ingresa tu contraseña" />
              
              <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                @if (showPassword()) {
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
                } @else {
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                }
              </button>
            </div>
            @if (userInfoForm.get('contrasena')?.invalid && userInfoForm.get('contrasena')?.touched) {
            <span class="error-text">La contraseña debe tener al menos 6 caracteres</span>
            }
          </div>

          <div class="form-group" [class.referral-highlight]="hasReferralCode()">
            <label class="form-label">
              @if (hasReferralCode()) {
                🎉 Código de Referido
              } @else {
                Código de Referido (Opcional)
              }
            </label>
            <div class="input-wrapper">
              <input 
                type="text" 
                formControlName="referralCode" 
                class="form-input" 
                [class.referral-input]="hasReferralCode()"
                placeholder="Ej: USUARIO123" />
              @if (hasReferralCode()) {
                <div class="referral-badge">✓ Invitado</div>
              }
            </div>
          </div>

          <div class="form-group checkbox-group">
            <label class="checkbox-label">
              <input type="checkbox" formControlName="terms" class="checkbox-input" />
              <span class="checkbox-custom"></span>
              <span class="checkbox-text">Acepto los <a href="assets/terminos.pdf" class="terms-link">Términos y
                  Condiciones</a></span>
            </label>
            @if (userInfoForm.get('terms')?.invalid && userInfoForm.get('terms')?.touched) {
            <span class="error-text">Debes aceptar los términos y condiciones</span>
            }
          </div>
        </form>

        <!-- Plan Selection -->
        <div class="plan-selection">
          <h3 class="section-title">Selecciona tu Plan</h3>

          @if (isLoadingPlans()) {
          <div class="loading-plans">
            <div class="spinner-large"></div>
            <p>Cargando planes disponibles...</p>
          </div>
          } @else if (plans.length === 0) {
          <div class="no-plans">
            <p>No hay planes disponibles en este momento</p>
          </div>
          } @else {
          <div class="plans-grid">
            @for (plan of plans; track plan.id) {
            <div class="plan-card" [class.selected]="selectedPlan()?.id === plan.id" [class.popular]="plan.popular"
              (click)="selectPlan(plan)">
              @if (plan.popular) {
              <div class="popular-badge">Más Popular</div>
              }
              <h4 class="plan-name">{{ plan.name }}</h4>
              <div class="plan-price">
                <span class="price-amount">${{ plan.price }}</span>
                <span class="price-period">/{{ plan.duration === 'monthly' ? 'mes' : plan.duration === 'annual' ? 'año'
                  : plan.durationDays + ' días' }}</span>
              </div>
              <ul class="plan-features">
                @for (feature of plan.features; track feature) {
                <li>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4 8L7 11L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  {{ feature }}
                </li>
                }
              </ul>
              <div class="plan-select-indicator">
                @if (selectedPlan()?.id === plan.id) {
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="#77d27a" />
                  <path d="M7 12L10 15L17 8" stroke="white" stroke-width="2.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                }
              </div>
            </div>
            }
          </div>
          }
        </div>

        <!-- Continue Button -->
        <button type="button" class="submit-button" (click)="goToStep2()">
          <span>Continuar al Pago</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      }

      <!-- STEP 2: Payment -->
      @if (currentStep() === 2) {
      <div class="step-content">
        <h1 class="title">
          @if (paymentMethod() === 'crypto') {
            Pago con criptomonedas
          } @else {
            Información de Pago
          }
        </h1>
        <p class="subtitle">
          @if (paymentMethod() === 'crypto') {
            Genera la dirección, envía el monto exacto y espera la confirmación del equipo.
          } @else {
            Completa los datos de tu tarjeta de crédito
          }
        </p>

        @if (canOfferCrypto()) {
        <div class="payment-method-toggle" role="tablist">
          <button type="button" class="method-tab" [class.active]="paymentMethod() === 'card'"
            (click)="selectPaymentMethod('card')" role="tab">Tarjeta</button>
          <button type="button" class="method-tab" [class.active]="paymentMethod() === 'crypto'"
            (click)="selectPaymentMethod('crypto')" role="tab">Criptomonedas</button>
        </div>
        }

        <!-- Error Message -->
        @if (errorMessage()) {
        <div class="error-message">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="#ff4444" stroke-width="2" />
            <path d="M10 6V10M10 14H10.01" stroke="#ff4444" stroke-width="2" stroke-linecap="round" />
          </svg>
          <span>{{ errorMessage() }}</span>
        </div>
        }

        <!-- ——— Cripto (NOWPayments) ——— -->
        @if (paymentMethod() === 'crypto') {
        @if (paymentStatus() === 'success') {
        <div class="payment-success">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="40" fill="rgba(119, 210, 122, 0.2)" />
            <path d="M25 40L35 50L55 30" stroke="#77d27a" stroke-width="4" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <h3>¡Todo listo!</h3>
          <p>Tu cuenta está activa. Inicia sesión con el correo y la contraseña que te enviamos.</p>
          <p class="crypto-hint">Redirigiendo al inicio de sesión…</p>
        </div>
        <div class="button-group single">
          <button type="button" class="secondary-button" (click)="goBackToStep1()">
            <span>Volver al inicio del registro</span>
          </button>
        </div>
        } @else if (cryptoCheckoutCreated()) {
        <div class="crypto-checkout">
          @if (paymentStatus() === 'processing') {
          <div class="crypto-processing-inline">
            <div class="processing-icon">
              <div class="spinner-large"></div>
            </div>
            <h3 class="crypto-processing-title">Creando tu cuenta…</h3>
            <p class="crypto-processing-text">Pago confirmado. Estamos completando tu registro en la plataforma.</p>
          </div>
          }
          @if (cryptoPriceAmount() !== null) {
          <div class="crypto-fiat-ref">
            Referencia: <strong>{{ cryptoPriceAmount() }} {{ cryptoPriceCurrency() | uppercase }}</strong>
          </div>
          }
          <div class="crypto-amount-row">
            <span class="label">Envía exactamente</span>
            <span class="value highlight">{{ cryptoPayAmount() }} {{ cryptoPayCurrencyCode() | uppercase }}</span>
          </div>
          <p class="crypto-warning">Importante: el monto debe coincidir exactamente (incluidos decimales); si no, el pago puede no acreditarse.</p>

          <div class="crypto-address-box">
            <span class="label">Dirección</span>
            <code class="crypto-address">{{ cryptoPayAddress() }}</code>
            <button type="button" class="copy-btn" (click)="copyToClipboard(cryptoPayAddress(), 'Dirección')">Copiar
              dirección</button>
          </div>

          @if (cryptoQrImageUrl()) {
          <div class="crypto-qr-wrap">
            <img [src]="cryptoQrImageUrl()" alt="QR de pago" class="crypto-qr" width="220" height="220" />
            <button type="button" class="copy-btn secondary" (click)="copyToClipboard(cryptoPaymentUri(), 'URI de pago')">Copiar
              URI del wallet</button>
          </div>
          }

          <div class="crypto-status-panel">
            <span class="crypto-status-label">Estado</span>
            <p class="crypto-status-text">{{ getCryptoStatusMessage() }}</p>
            @if (cryptoEstado() === 'Esperando_Confirmacion' || cryptoEstado() === 'Pendiente') {
            <p class="crypto-poll-note">Actualizamos el estado automáticamente cada ~20 s.</p>
            }
          </div>

          @if (cryptoEstado() === 'Fallido') {
          <div class="button-group">
            <button type="button" class="secondary-button" (click)="goBackToStep1()">Volver</button>
            <button type="button" class="submit-button" (click)="retryCryptoPayment()">Generar nuevo pago</button>
          </div>
          } @else {
          <div class="button-group single">
            <button type="button" class="secondary-button" (click)="goBackToStep1()"
              [disabled]="isLoading()">Volver</button>
          </div>
          }
        </div>
        } @else {
        <div class="crypto-intro">
          <div class="form-group">
            <label class="form-label">Moneda cripto</label>
            <select class="form-input crypto-select" [value]="payCurrency()"
              (change)="onPayCurrencyChange($event)">
              @for (opt of cryptoCurrencyOptions; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>
          </div>
          <p class="crypto-info">
            Tras crear el pago verás la dirección y el monto. Cuando la red confirme, crearemos tu cuenta y te enviaremos
            una contraseña por correo. Un administrador debe validar el pago antes de que puedas iniciar sesión.
          </p>
          <div class="payment-summary">
            <div class="summary-row">
              <span>Plan:</span>
              <strong>{{ selectedPlan()?.name }}</strong>
            </div>
            <div class="summary-row total">
              <span>Correo (login):</span>
              <strong>{{ userInfoForm.get('email')?.value }}</strong>
            </div>
          </div>
          <div class="button-group">
            <button type="button" class="secondary-button" (click)="goBackToStep1()" [disabled]="isLoading()">
              <span>Volver</span>
            </button>
            <button type="button" class="submit-button" (click)="createCryptoPayment()" [disabled]="isLoading()">
              @if (isLoading()) {
              <span class="spinner"></span>
              <span>Generando…</span>
              } @else {
              <span>Generar pago cripto</span>
              }
            </button>
          </div>
        </div>
        }
        }

        <!-- ——— Tarjeta (APay) ——— -->
        @if (paymentMethod() === 'card') {
        <!-- Payment Status: Processing (without iframe) -->
        @if (paymentStatus() === 'processing' && !iframeUrl()) {
        <div class="payment-processing">
          <div class="processing-icon">
            <div class="spinner-large"></div>
          </div>
          <h3>Procesando tu pago...</h3>
          <p>Por favor espera mientras verificamos tu transacción</p>
        </div>
        }

        <!-- APay Iframe -->
        @if (iframeUrl()) {
        <div class="payment-iframe-container visible">
          <iframe #paymentIframe class="payment-iframe" frameborder="0">
          </iframe>
        </div>
        }

        <!-- Payment Status: Success -->
        @if (paymentStatus() === 'success') {
        <div class="payment-success">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="40" fill="rgba(119, 210, 122, 0.2)" />
            <path d="M25 40L35 50L55 30" stroke="#77d27a" stroke-width="4" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <h3>¡Pago Exitoso!</h3>
          <p>Tu suscripción ha sido activada correctamente</p>
        </div>
        }

        <!-- Payment Form (only if idle or failed AND no iframe active) -->
        @if ((paymentStatus() === 'idle' || paymentStatus() === 'failed') && !iframeUrl()) {
        <form [formGroup]="paymentForm" class="payment-form">
          <div class="form-group">
            <label class="form-label">Número de Tarjeta {{ getCardTypeIcon() }}</label>
            <div class="input-wrapper">
              <input type="text" formControlName="cardNumber" class="form-input" placeholder="1234 5678 9012 3456"
                maxlength="19" (input)="formatCardNumber($event)" />
            </div>
            @if (paymentForm.get('cardNumber')?.invalid && paymentForm.get('cardNumber')?.touched) {
            <span class="error-text">Número de tarjeta inválido</span>
            }
          </div>

          <div class="form-group">
            <label class="form-label">Nombre del Titular</label>
            <div class="input-wrapper">
              <input type="text" formControlName="cardholderName" class="form-input" placeholder="NOMBRE APELLIDO"
                style="text-transform: uppercase;" />
            </div>
            @if (paymentForm.get('cardholderName')?.invalid && paymentForm.get('cardholderName')?.touched) {
            <span class="error-text">Nombre del titular requerido</span>
            }
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Fecha de Expiración</label>
              <div class="input-wrapper">
                <input type="text" formControlName="expiryDate" class="form-input" placeholder="MM/YY" maxlength="5"
                  (input)="formatExpiryDate($event)" />
              </div>
              @if (paymentForm.get('expiryDate')?.invalid && paymentForm.get('expiryDate')?.touched) {
              <span class="error-text">Formato: MM/YY</span>
              }
            </div>

            <div class="form-group">
              <label class="form-label">CVV</label>
              <div class="input-wrapper">
                <input type="text" formControlName="cvv" class="form-input" placeholder="123" maxlength="4" />
              </div>
              @if (paymentForm.get('cvv')?.invalid && paymentForm.get('cvv')?.touched) {
              <span class="error-text">CVV inválido</span>
              }
            </div>
          </div>
        </form>

        <!-- Payment Summary -->
        <div class="payment-summary">
          <div class="summary-row">
            <span>Plan seleccionado:</span>
            <strong>{{ selectedPlan()?.name }}</strong>
          </div>
          <div class="summary-row total">
            <span>Total a pagar:</span>
            <strong>${{ selectedPlan()?.price }}</strong>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="button-group">
          <button type="button" class="secondary-button" (click)="goBackToStep1()" [disabled]="isLoading()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12 4L6 10L12 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Volver</span>
          </button>
          <button type="button" class="submit-button" (click)="processPayment()" [disabled]="isLoading()">
            @if (isLoading()) {
            <span class="spinner"></span>
            <span>Procesando...</span>
            } @else {
            <span>Pagar Ahora</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M6 10L9 13L14 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            }
          </button>
        </div>
        }
        }
        <!-- fin paymentMethod card -->
      </div>
      }
    </div>
  </div>
</div>